<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Tipos de Cargo</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cxp-tipo-cargo-nuevo', params: {} }"
              >
                <i class="fa fa-plus"></i>
                Nueva Tipo de Cargo
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <form action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <!-------------------- Tabla de REsultados -------------------->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Nombre</th>
                <th scope="col" class="text-center">Excento de IVA</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td scope="row">{{ current.id }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div
                    v-if="current.excento_iva"
                    class="status-pill green"
                    data-title="Activo"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.excento_iva"
                    class="status-pill red"
                    data-title="Inactiva"
                    data-toggle="tooltip"
                  ></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import TipoCargoService from "@/services/cxp/TipoCargoService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      searchtext: "",
      data: [],
    };
  },
  computed: {},
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    refreshData(params) {
      let self = this;
      TipoCargoService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxp-tipo-cargo-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxp-tipo-cargo-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
